import { store } from '../app/store';
import { AppConstants } from '../constants/AppConstants';

let roleAPIPermisions: any = {};
let userRoleName;
let ignorePermissionCheck: any;
let applicationFeatures:Feature[]=[]

export interface Operation {
  id: string;
  actionName: string;
  description: string;
  status: string;
  apiPermissions: string[];
  featureId: string;
}
export interface Tag {
  key: string;
  expiredOn: string;
}
export interface Feature {
  id: string;
  name: string;
  description: string;
  status: string;
  operations: Operation[];
  tags: Tag[];
}
export interface MenuItem {
  key: string;
  path: string;
  label: string;
  iconSource: string; // This is a path to the SVG or image file
}
export interface configureObj {
  moduleRoutes: any;
  menuItsmsList: MenuItem[];
}

const setApiPermissions = (state: any) => {
  roleAPIPermisions = state.initialLoadData?.apiPermissions || {};
  userRoleName = state.userManagement.userRole || '';
  ignorePermissionCheck = userRoleName === AppConstants.USER_ROLE_IT_ADMIN;
  applicationFeatures= state.initialLoadData?.applicationFeatures || []
};

const listener = () => {
  setApiPermissions(store.getState());
};

store.subscribe(listener);

export const apiPermissionCheck = (apiPermissions: string[] = []) => {
  return apiPermissions.length
    ? apiPermissions.filter((apiPermission: string) => roleAPIPermisions[apiPermission]).length ===
        apiPermissions.length
    : false;
};

export const checkForPermission = (permission: string[] = []) => {
  return ignorePermissionCheck ? true : apiPermissionCheck(permission);
};

/**
 * Checks if the specified feature or operation is allowed based on the provided application features.
 * @param {string} featureName - The name of the feature to check, which can include nested features separated by dots.
 * @param {boolean} allOperations - A flag indicating whether to check all operations or just a specific one.
 * @returns {boolean} - Returns true if the feature or operation is allowed, otherwise false.
 */

export const checkFeaturePermission = (
  featureName: string,
  allOperations: boolean
) => {
  if (ignorePermissionCheck) {
    return true;
  } else {
    const featuresList: string[] = featureName.split('.');
    let isAllowed = true;
    if (allOperations) {
      // Check if all features in the list are active
      isAllowed = featuresList.every((featureName: string) =>
        applicationFeatures.some(
          (feature: Feature) => feature.name === featureName && feature.status === 'ACTIVE'
        )
      );
    } else {
      // Extract the operation name from the feature name list
      const operationName: string = featuresList.pop() || '';

      // Check if each feature in the list is active and the final feature has the specified active operation
      isAllowed = featuresList.every((featureName: string, index: number) => {
        const availableFeature = applicationFeatures.find(
          (feature: Feature) => feature.name === featureName && feature.status === 'ACTIVE'
        );

        if (!availableFeature) return false;
        // If it's the last feature in the list, check for the active operation
        if (featuresList.length - 1 === index) {
          return availableFeature.operations.some(
            (operation: Operation) =>
              operation.actionName === operationName && operation.status === 'ACTIVE'
          );
        }
        return true;
      });
    }
    return isAllowed;
  }
};
